import { Box, Button, CircularProgress, Container, CssBaseline, Grid, Link, TextField, Typography } from '@mui/material'
import Copyright from 'components/Copyright'
import React, { useState } from 'react'
import { Navigate, Link as RouterLink } from 'react-router'
import { SignupActions, SignupStoreStates } from '.'
import { Form, Paper } from './styles'

type OwnProps = {}

type SignupProps = OwnProps & SignupStoreStates & SignupActions

const Signup = (props: SignupProps) => {
  const { auth } = props
  const { signingUp, signUpError, user } = auth
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmationPassword, setConfirmationPassword] = useState('')
  const [isEmpty, setIsEmpty] = useState(true)
  const [isMatchPassword, setIsMatchPassword] = useState(true)

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (isEmpty || !isMatchPassword) return
    props.signUp({ name, email, password })
  }

  const checkInputs = () => {
    const state = { name, email, password, confirmationPassword }
    setIsEmpty(Object.values(state).includes(''))
    setIsMatchPassword(password === confirmationPassword)
  }

  if (user) {
    return <Navigate replace to="/notifications" />
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper>
        <img src="/images/logo.png" alt="logo" />

        <Typography color="textSecondary" component="h5" variant="h6">
          アカウント作成
        </Typography>

        {signUpError && (
          <Typography color="error" component="h1" variant="h6">
            {auth.signUpError}
          </Typography>
        )}

        <Form noValidate onSubmit={(e) => onSubmit(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="名前"
            type="text"
            autoComplete="name"
            autoFocus
            value={name}
            onChange={({ target }) => {
              setName(target.value)
              checkInputs()
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="メールアドレス"
            type="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={({ target }) => {
              setEmail(target.value)
              checkInputs()
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="パスワード"
            autoComplete="password"
            type="password"
            value={password}
            onChange={({ target }) => {
              setPassword(target.value)
              checkInputs()
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="パスワード（確認用）"
            autoComplete="confirmation_password"
            type="password"
            value={confirmationPassword}
            error={!isMatchPassword}
            helperText={!isMatchPassword && 'パスワードが一致しません'}
            onChange={({ target }) => {
              setConfirmationPassword(target.value)
              checkInputs()
            }}
          />

          <Typography align="center" color="textSecondary" component="h5" variant="h6">
            ※ 名前は後から変更できません
          </Typography>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isEmpty || !isMatchPassword || signingUp}
            sx={{ mt: 3, mb: 2 }}>
            {signingUp ? <CircularProgress size={20} /> : 'サインアップ'}
          </Button>
        </Form>
        <Grid container>
          <Grid size="grow" />
          <Grid>
            <Link to="/login" component={RouterLink}>
              アカウントをお持ちの方はこちら
            </Link>
          </Grid>
        </Grid>
      </Paper>
      <Box
        sx={{
          mt: 8,
        }}>
        <Copyright />
      </Box>
    </Container>
  )
}

export default Signup
